import React from 'react';
import styled from 'styled-components';

import CtaPrimary from 'components/ui/CtaPrimary';
import Spacer from 'components/ui/Spacer';

import { colors } from 'helpers/ColorHelper';

const StyledButton = styled(CtaPrimary)`
  background-color: ${props => (props.disabled ? colors.LIGHT_GREY : colors.GREY_BLUE)} !important;
  color: ${props => (props.disabled ? colors.CHAR_COUNT : colors.STATE_BLUE)} !important;
  font-size: 18px;
  font-weight: bold;
  width: 200px;
  height: 48px;
  line-height: 48px;
  margin-top: 32px;
`;

const StyledOuterContainer = styled.div`
  background: ${props => props.background || 'var(--very-light-bg)'};
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const StyledInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 330px;
`;

const StyledHeading = styled.div`
  font-size: 18px;
  color: ${colors.BLACK_RUSSIAN};
  font-family: 'Circular-Black';
`;

const StyledBody = styled.div`
  font-size: 18px;
  color: ${colors.SLATE_GREY};
`;

const BodySpacer = styled(Spacer)`
  line-height: 1;
`;

const DocumentTemplateWizardError = ({
  headerText,
  bodyText,
  onClick,
  buttonText,
  background,
  iconSource,
  disabled,
}) => {
  const cta =
    onClick && buttonText ? (
      <StyledButton onClick={onClick} disabled={disabled}>
        {buttonText}
      </StyledButton>
    ) : null;

  return (
    <React.Fragment>
      <StyledOuterContainer background={background}>
        <StyledInnerContainer>
          <Spacer mb={2}>{iconSource}</Spacer>
          <Spacer mb={1}>
            <StyledHeading>{headerText}</StyledHeading>
          </Spacer>
          <BodySpacer mb={1}>
            <StyledBody>{bodyText}</StyledBody>
          </BodySpacer>
          <div>
            <Spacer mb={1}>
              <div>{cta}</div>
            </Spacer>
          </div>
        </StyledInnerContainer>
      </StyledOuterContainer>
    </React.Fragment>
  );
};

export default DocumentTemplateWizardError;
